import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { AuthLayout, AuthInput, AuthAlert, PrimaryButton, SecondaryButton } from './layout/AuthLayout';

const ResetPassword: React.FC = () => {
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    try {
      const response = await authService.resetPassword(token, newPassword);
      setMessage(response.message);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error resetting password');
    }
  };

  return (
    <AuthLayout title="Reset Password" subtitle="Enter your reset token and new password">
      {error && <AuthAlert severity="error">{error}</AuthAlert>}
      {message && <AuthAlert severity="success">{message}</AuthAlert>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <AuthInput
          label="Reset Token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          required
        />
        <AuthInput
          label="New Password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoComplete="new-password"
          required
        />
        <AuthInput
          label="Confirm Password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          autoComplete="new-password"
          required
        />
        <div className="pt-2">
          <PrimaryButton type="submit">Reset Password</PrimaryButton>
        </div>
        <SecondaryButton type="button" onClick={() => navigate('/login')}>
          Back to Login
        </SecondaryButton>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;
